/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";

import Typography from "@material-ui/core/Typography";

import ToolbarButton from "./../ToolbarButton";

import CartIcon from "@material-ui/icons/ShoppingCart";
import WarningIcon from "@material-ui/icons/Warning";
import RemoveShoppingCartIcon from "@material-ui/icons/RemoveShoppingCart";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Badge from "@material-ui/core/Badge";

import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";

import axios from "axios";

import { useStoreon } from "storeon/react";

import t from "../../translations";

import confirm from "../Dialog";

const CartWrap = styled.div`
  position: absolute;
  z-index: 9999;
  border: 3px solid #3b3b3b;
  top: 60px;
  right: 10px;
  background: #fff;
  padding: 10px;
  color: #222;
  min-width: 400px;
  max-height: 80vh;
  overflow: hidden;
  overflow-y: auto;
  display: ${props => (props.visible ? "block" : "none")};
  > ul {
    padding: 0;
    margin: 0;
  }
  @media screen and (max-width: 480px) {
    min-width: 340px;
    right: 0px;
  }
`;

const CartItemWrap = styled.li`
  user-select: none;
  display: flex;
  align-items: stretch;
  list-style: none;
  justify-content: space-between;
  padding: 5px 10px;
  border-bottom: 1px solid #848484;
  color: #343434;
  cursor: pointer;
  &:hover {
    background: #eee;
  }
  &.active {
    background: #ddd;
  }
  > svg {
    height: 19px;
    width: 19px;
  }
  > span {
    height: 22px;
    margin-left: 10px;
  }

  .product {
    > b {
      font-size: 14px;
    }
    > div {
      margin-top: 3px;
      display: flex;
      flex-direction: row;
      font-size: 13px;
      .meta {
        > div {
        }
        font-size: 12px;
      }
      .thumb {
        width: 100px;
        height: 65px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        /* border: 1px solid #ccc; */
        margin-right: 10px;
        > img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }

  .price {
    display: flexAqweqw e fs;
    flex-direction: column;
    justify-content: flex-start;
    flex-basis: 25%;
    padding: 3px 0;
    > b {
      font-size: 14px;
      line-height: normal;
    }
    > div {
      font-size: 12px;
    }
    > .controls {
      flex-basis: 100%;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: flex-start;
      margin-left: -5px;
      margin-bottom: -3px;
      > svg:hover {
        color: gray;
      }
    }
  }
`;

const CartItem = props => {
  const { key, quantity, price, meta, thumb, name, tax, dpe } = props.item;
  const { onEdit, onRemove, active } = props;
  return (
    <CartItemWrap>
      <div className="product">
        <b>
          {name}
          {"\u00A0\u00A0\u00A0"}x {quantity}{" "}
          {active && (
            <Typography
              color="primary"
              css={css`
                font-weight: 800;
                display: inline;
              `}
            >
              {"<- Editing"}
            </Typography>
          )}
        </b>
        <div>
          <div className="thumb">
            <img src={thumb} alt={t.cartItemThumb} />{" "}
          </div>
          <div className="meta">
            {meta.map(item => {
              if (item.name) {
                return (
                  <div key={item.name}>
                    <b>{item.name}: </b>
                    <span dangerouslySetInnerHTML={{ __html: item.value }} />
                  </div>
                );
              } else {
                return null;
              }
            })}
          </div>
        </div>
      </div>
      <div className="price">
        <b>{price.toDPEFormat()}€</b>
        <div className="tax">inkl.{tax.toDPEFormat()}€ MwSt.</div>
        <div className="controls">
          <DeleteIcon
            onClick={_ => {
              onRemove(key);
            }}
          />
          {dpe && (
            <EditIcon
              onClick={_ => {
                onEdit(props.item);
              }}
            />
          )}
        </div>
      </div>
    </CartItemWrap>
  );
};

const CartHeader = styled.div`
  border-bottom: 4px solid #343434;
  margin: 0 8px;
  > h3 {
    margin: 0px;
    margin-bottom: 10px;
    font-size: 17px;
  }
  > div {
    display: flex;
    justify-content: space-between;

    > span {
      font-weight: bold;
      font-size: 14px;
      &.product {
        padding: 2px 4px;
      }
      &.price {
        padding: 2px 0px;
        flex-basis: 25%;
      }
    }
  }
`;

const CartFooter = styled.div`
  width:66%;
  float:right;
  font-size:14px;
  >div {
    padding-left:7px;
  }
  .info {
    line-height:2.4;
  }
  .subtotal {
    border-bottom:2px solid #333;
  }
  .total {
    background:#ebeaea;
    display:flex;
    flex-direction:row;
    justify-content: space-between;
    align-items: center;
    font-size:15px;
    > .price {
      background:#f7f7f7;
      border:3px solid #adbb55;
      padding: 8px;
      > b {
        font-size:18px;
        color:#adbb55
      }
      >div {
        font-size:12px;
      }

    }
  }
  }
`;

const CartContent = props => {
  const { visible } = props;
  const { dispatch, cart, canvas, cartId } = useStoreon(
    "cachePool",
    "canvas",
    "cart",
    "cartId"
  );

  const handleRemove = async key => {
    const result = await confirm.show({
      icon: <RemoveShoppingCartIcon style={{ marginRight: 10 }} />,
      text: t.removeFromCartWarn,
      title: t.removeFromCart
    });
    if (!result) {
      return;
    }
    try {
      const resp = await axios.delete("/wp-json/dpe/v1/cart", {
        data: { key }
      });
      if (cartId === key) {
        dispatch("canvas/new");
        dispatch("notification/success", t.newCanvasCreated);
      }
      if (resp.data.cart) {
        dispatch("cart/set", resp.data.cart);
      }
    } catch (err) {
      console.error("Remove from cart", err);
    }
  };

  const handleEdit = async item => {
    if (!canvas.DPE.persistent.isCanvasEmpty()) {
      const result = await confirm.show({
        icon: <WarningIcon style={{ marginRight: 10 }} />,
        text: t.editCartItemWarn,
        title: t.designUnsaved
      });
      if (!result) {
        return;
      }
    }
    if (item.dpe && item.dpe.canvasData) {
      dispatch("init/cartItem", item.key );
    }
  };

  return (
    <CartWrap visible={visible}>
      {cart.items.length ? (
        <CartHeader>
          <h3>{t.cartContent}</h3>
          <div>
            <span className="product">{t.product}</span>
            <span className="price">{t.price}</span>
          </div>
        </CartHeader>
      ) : (
        <Typography style={{ textAlign: "center" }}>{t.cartIsEmpty}</Typography>
      )}
      <ul>
        {cart.items.map(item => (
          <CartItem
            active={cartId === item.key}
            item={item}
            key={item.key}
            onRemove={handleRemove}
            onEdit={handleEdit}
          />
        ))}
      </ul>
      {cart.items.length > 0 && (
        <CartFooter>
          {/* <div className="subtotal">subtotal</div> */}
          <div className="info">{t.deliveryIsFree}</div>
          <div className="total">
            <span>
              <b>{t.total}:</b>
            </span>
            <span className="price">
              <b>{parseFloat(cart.total,10).toDPEFormat()}€</b>
              <div>inkl. {cart.tax?.toDPEFormat()}€ MwSt.</div>
            </span>
          </div>
        </CartFooter>
      )}
      {cart.items.length > 0 && (
        <Link href={cart.url}>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            css={css`
              margin-top: 10px;
            `}
          >
            {t.goToCart}
          </Button>
        </Link>
      )}
    </CartWrap>
  );
};

const Cart = () => {
  const [isCartVisible, setIsCartVisible] = useState(false);

  const { dispatch, cart } = useStoreon("cart");
  useEffect(_ => {
    axios
      .get("/wp-json/dpe/v1/cart")
      .then(resp => {
        console.info("Cart ", resp.data);
        if (resp.data.items) {
          dispatch("cart/set", resp.data);
        }
      })
      .catch(err => {
        console.error("Cart data failed", err);
      });
  }, [dispatch]);
  const handleAwayClick = e => {
    const wrap = e.target.parentElement?.parentElement?.parentElement;
    if (
      !wrap ||
      wrap?.classList.contains("deskpad-cart") ||
      !wrap?.parentElement ||
      wrap?.parentElement?.classList?.contains("deskpad-cart")
    ) {
      return;
    }
    setIsCartVisible(false);
  };


  return null;

  return (
    <div className="deskpad-cart">
      <ToolbarButton
        dark
        active={isCartVisible}
        onClick={e => {
          setIsCartVisible(is => !is);
          e.stopPropagation();
        }}
        vertical
        icon={
          <Badge badgeContent={cart.items.length} color="secondary">
            <CartIcon style={{ fontSize: 27 }} />
          </Badge>
        }
      />
      <ClickAwayListener onClickAway={handleAwayClick}>
        {CartContent({ visible: isCartVisible })}
      </ClickAwayListener>
    </div>
  );
};

export default Cart;
